module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hgnx5"))).then(() => module.bundle.root('1iHdE'));